var map = {
	"./decidim/avatar-multiuser.png": 362,
	"./decidim/brands/google.svg": 12069,
	"./decidim/cc-badge.png": 97831,
	"./decidim/decidim-logo.svg": 41912,
	"./decidim/default-avatar.svg": 960,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 47644,
	"./decidim/icons.svg": 98683,
	"./decidim/pattern.png": 6364,
	"./decidim/placeholder-card-g.svg": 15097,
	"./decidim/placeholder-card-l.svg": 26994,
	"./decidim/placeholder.jpg": 39985,
	"./decidim/remixicon.symbol.svg": 39125,
	"./decidim/vendor/leaflet/layers-2x.png": 47732,
	"./decidim/vendor/leaflet/layers.png": 50739,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 81486,
	"./decidim/vendor/leaflet/marker-icon.png": 14677,
	"./decidim/vendor/leaflet/marker-shadow.png": 74842,
	"./decidim/vendor/social-share-button/douban.svg": 56484,
	"./decidim/vendor/social-share-button/email.svg": 20929,
	"./decidim/vendor/social-share-button/facebook.svg": 95719,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 52889,
	"./decidim/vendor/social-share-button/hacker_news.svg": 98225,
	"./decidim/vendor/social-share-button/linkedin.svg": 1281,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 45122,
	"./decidim/vendor/social-share-button/pinterest.svg": 25975,
	"./decidim/vendor/social-share-button/reddit.svg": 31131,
	"./decidim/vendor/social-share-button/telegram.svg": 60222,
	"./decidim/vendor/social-share-button/tumblr.svg": 89181,
	"./decidim/vendor/social-share-button/twitter.svg": 46704,
	"./decidim/vendor/social-share-button/vkontakte.svg": 81502,
	"./decidim/vendor/social-share-button/wechat.svg": 81977,
	"./decidim/vendor/social-share-button/whatsapp.svg": 61793,
	"./decidim/vendor/social-share-button/x.svg": 20489,
	"./decidim/vendor/social-share-button/xing.svg": 95751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72777;